import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { reviewsSelector } from '../../../../../store/slices/reviews';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { Chip, Stack, Tooltip, Typography } from '@mui/material';
import _ from 'lodash';

const TopicSentiments = () => {
    // Get reviewTopicDetails from Redux store
    const { reviewTopicDetails ,similarReviews} = useSelector(reviewsSelector);

 
    // Define columns for the table
    const columns = useMemo(() => [
        {
            header: 'Topics',
            size: 60,
            accessorKey: 'sentiment',
            Cell: ({ row }) => {
                const arr = row?.original?.sentiment?.split(':');

                return (
                    <span>
                        <Tooltip
                            arrow
                            disableInteractive
                            title={
                                <Stack>
                                    <Typography variant="caption">
                                        Sentiment: {arr[1]}
                                    </Typography>
                                    <Typography variant="caption">
                                        Strength: {row?.original?.strength}
                                    </Typography>
                                </Stack>
                            }
                        >
                            <Chip
                                label={`${arr[0]} (${row?.original?.strength})`}
                                size="small"
                                color={
                                    arr[1]
                                        ? arr[1] === 'Negative'
                                            ? 'error'
                                            : arr[1] === 'Positive'
                                            ? 'success'
                                            : 'warning'
                                        : 'secondary'
                                }
                            />
                        </Tooltip>
                    </span>
                );
            }
        },
        {
            header: 'Phrases',
            accessorKey: 'phrasesString',
            Cell: ({ row }) => {
                const arr = JSON.parse(row?.original?.phrasesString);
                return (
                    <Stack>
                        {_.map(arr, (it, index) => (
                            <li key={index}>{it}</li>
                        ))}
                    </Stack>
                );
            }
        },
        {
            header: 'Explanation',
            accessorKey: 'explanation',
        }
    ], []);

    // Memoize the table data
    const tableData = useMemo(() => similarReviews?.sentiments ?? [], [similarReviews?.sentiments]);

    // Create the table instance
    const table = useMaterialReactTable({
        columns,
        data: tableData,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        enableColumnFilters: false,
        enableTopToolbar: false,
        enableBottomToolbar: false,
        enableSorting: false,
        enableHiding: false,
        enableColumnActions: false,
        muiTableContainerProps: {
            sx: {
                maxHeight: 'unset'
            }
        },
        muiTablePaperProps: {
            className: 'std_table review-requests',
            sx: { boxShadow: 'none' }
        },
        muiTableBodyCellProps: {
            sx: { border: 'none' }
        }
    });

    return (
        <>
            <MaterialReactTable table={table} />
        </>
    );
};

export default TopicSentiments;
